import React, { FC, useState } from "react";
import { Button, Modal, ModalBody } from "reactstrap";

export interface DeleteModalBody {
  deleteFunc: any;
  deleteObjTitle: string;
}

const DeleteModalBody: FC<DeleteModalBody> = ({
  deleteFunc,
  deleteObjTitle,
}) => {
  const [deleteMe, setDeleteMe] = useState("");
  return (
    <>
      <ModalBody>
        <div className="mb-3">
          "{deleteObjTitle}
          "を削除するには、"delete"と入力してください
        </div>
        <div>
          <input
            className="p-2 mx-2"
            placeholder="delete"
            value={deleteMe}
            onChange={(e) => setDeleteMe(e.target.value)}
          />
          {deleteMe == "delete" ? (
            <Button
              className="ema__backgroundColor__red"
              onClick={(e) => deleteFunc()}
            >
              削除
            </Button>
          ) : (
            <Button disabled>削除</Button>
          )}
        </div>
      </ModalBody>
    </>
  );
};

export default DeleteModalBody;
